module.exports = __webpack_public_path__ + "img/DROP-10-820x1024.ecebf13c.png";